import $date from '@/services/date'

export default function formatDate(date, format = 'll') {
  return $date(date).format(format)
}
